// extracted by mini-css-extract-plugin
export default {"header":"Header_header__GeDpP","logoTitle":"Header_logoTitle__IZL4m","logo":"Header_logo__MiIpL","title":"Header_title__FXd+q","tagline":"Header_tagline__Er1HG"};